module.exports = __webpack_public_path__ + "static/about-cloud-img-1100px-1c4f21263b3af7b813458475f77be3e8.png";